import { List, Record, type RecordOf } from 'immutable';

export type ColumnProps = {
  id?: number;
  field?: string;
  headerName?: string;
};
export type Column = RecordOf<ColumnProps>;
export const mkColumn = Record<ColumnProps>({
  id: undefined,
  field: undefined,
  headerName: undefined,
});

export type CellProps = {
  id?: number;
  columnId?: number;
  value?: number;
};
export type Cell = RecordOf<CellProps>;
export const mkCell = Record<CellProps>({
  id: undefined,
  columnId: undefined,
  value: undefined,
});

export type RowProps = {
  id?: number;
  name?: string;
  entityId?: number;
  cellData?: Cell[];
};
export type RowRecord = RecordOf<RowProps>;
const Row = Record<RowProps>({
  id: undefined,
  name: undefined,
  entityId: undefined,
  cellData: undefined,
});
export const mkRow = (obj: any) =>
  Row({
    ...(obj?.toJS?.() || obj),
    cellData: List(obj?.cellData?.map(mkCell)),
  });

export type ReportStoreProps = {
  startOn?: string;
  endOn?: string;
  timestep?: string;
  rowType?: string;
  columnType?: string;
  columns?: Column[];
  rows?: RowRecord[];
  loadPending?: boolean;
  isLoading?: boolean;
  error?: string;
};
const ReportStore = Record<ReportStoreProps>({
  startOn: undefined,
  endOn: undefined,
  timestep: undefined,
  rowType: undefined,
  columnType: undefined,
  columns: undefined,
  rows: undefined,

  loadPending: true,
  isLoading: false,
  error: undefined,
});

export const mkReportStore = (obj: any) =>
  ReportStore({
    ...(obj?.toJS?.() || obj),
    columns: List(obj?.columns?.map(mkColumn)),
    rows: List(obj?.rows?.map(mkRow)),
  });
